import React from 'react'
import classNames from 'classnames'
import DateFormat from '../../../../shared/helpers/date-format'
import HoursMessage from './hours-message'

let { timeShort } = DateFormat

const Hours = ({ hours, highlight }) => {
  let open = timeShort(new Date(hours.openTime)).toLowerCase()
  let close = timeShort(new Date(hours.closeTime)).toLowerCase()

  return (
    <div
      style={{ minHeight: '3.75rem' }}
      className={classNames({
        'text-white': highlight
      })}
    >
      {(hours.openTime || hours.closedTime) && (
        <span className="block mb-8 text-16">
          <span className="lg:hidden">Open</span> {open}-{close}
        </span>
      )}
      {hours.messages.map(message => (
        <HoursMessage
          key={message}
          message={message}
        />
      ))}
    </div>
  )
}

export default Hours
